import WarningException from '@/module/common/service/Exception/WarningException';

class NumberFormatException extends WarningException {}

export default NumberFormatException;
